module.exports = __webpack_public_path__ + "static/media/Flaticon.04b46abd.ttf";